<app-resume-send-modal #resumeSendModal (eventResumeSend)="eventModalResumeSend($event)"></app-resume-send-modal>
<app-resume-send-login-modal #resumeSendLoginModal></app-resume-send-login-modal>
